<template>
  <c-q-btn
    v-if="showCancelButton"
    id="btn-cancel-create-new-institutional"
    propBtnLabel="Cancelar"
    :propBtnFunction="backToPreviousPage"
    :propBtnTransparent="true"
    :propBtnSize="EnumButtonSizes.LARGE_1"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'
import { useInstitutionalStore } from '@/stores/institutionalStore'

const router = useRouter()
const institutionalStore = useInstitutionalStore()

/**
 * ✅ Mostrar botão apenas quando estiver criando novo cadastro
 */
const showCancelButton = computed(() => {
  return !institutionalStore.institutionalDraft.id
})

/**
 * ✅ Voltar para tela de pesquisa
 */
const backToPreviousPage = () => {
  router.push({ name: EnumRouteNames.INSTITUTIONAL_SEARCH })
}
</script>

<style scoped>
</style>